module.exports = __webpack_public_path__ + "static/media/value_protect_bg.0dcc8cb3.jpg";